import { __rest, __read, __assign } from 'tslib';
import React__default, { useContext } from 'react';
import ReactTooltipTrigger from 'react-popper-tooltip';
import classNames from 'classnames';
import { CartContext } from '../../context/CartContext.esm.js';
import '../../context/CartSettingsContext.esm.js';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import '../../constants/api.esm.js';
import { useDetectMobileDevice } from '@invitae/react-hooks';
import TooltipMiniCart from './TooltipMiniCart.esm.js';
import TooltipTrigger from './TooltipTrigger.esm.js';
import styles from './MiniCart.module.esm.js';

var PopperProps = {
    modifiers: [
        {
            name: 'preventOverflow',
            options: {
                altBoundary: 'document',
                boundary: 'viewport',
                padding: 4,
            },
        },
    ],
};
var MiniCart = function (_a) {
    var children = _a.children, className = _a.className, handleCartClick = _a.handleCartClick, _b = _a.delayHide, delayHide = _b === void 0 ? 400 : _b, _c = _a.isKeepingMiniCartOpenAllowed, isKeepingMiniCartOpenAllowed = _c === void 0 ? true : _c, partnershipCode = _a.partnershipCode, _d = _a.placement, placement = _d === void 0 ? 'bottom' : _d, tooltipClassName = _a.tooltipClassName, triggerComponent = _a.triggerComponent, rest = __rest(_a, ["children", "className", "handleCartClick", "delayHide", "isKeepingMiniCartOpenAllowed", "partnershipCode", "placement", "tooltipClassName", "triggerComponent"]);
    var _e = useContext(CartContext), gotoCartPage = _e.gotoCartPage, closeOpenedMiniCart = _e.closeOpenedMiniCart, partnershipWarning = _e.partnershipWarning, shouldShowPartnershipWarning = _e.shouldShowPartnershipWarning, shouldKeepMiniCartOpen = _e.shouldKeepMiniCartOpen, shouldSkipGotoCartByClickingIcon = _e.shouldSkipGotoCartByClickingIcon;
    var isMobile = useDetectMobileDevice();
    var _f = __read(React__default.useState(false), 2), isCursorInsideMiniCart = _f[0], setIsCursorInsideMiniCart = _f[1];
    var miniCartTooltipRef = React__default.useRef(null);
    React__default.useEffect(function () {
        var hideMiniCartOnOutsideClick = function (event) {
            var _a;
            if (!((_a = miniCartTooltipRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)))
                closeOpenedMiniCart();
        };
        document.body.addEventListener('click', hideMiniCartOnOutsideClick);
        return function () { return document.body.removeEventListener('click', hideMiniCartOnOutsideClick); };
    }, [closeOpenedMiniCart]);
    var isGoToCartPageProvided = gotoCartPage.name !== 'noop';
    return (React__default.createElement("div", __assign({ className: classNames(className, styles.wrapper) }, (!shouldSkipGotoCartByClickingIcon && !isMobile && { onClick: gotoCartPage }), (!isGoToCartPageProvided && { onClick: handleCartClick }), { onMouseEnter: function () { return setIsCursorInsideMiniCart(true); }, onMouseLeave: function () { return setIsCursorInsideMiniCart(false); }, role: "presentation" }),
        React__default.createElement(ReactTooltipTrigger, __assign({ delayHide: delayHide, placement: placement, tooltip: function (props) { return (React__default.createElement(TooltipMiniCart, __assign({ actionsContent: children, className: tooltipClassName, forwardRef: miniCartTooltipRef, isCursorInsideMiniCart: isCursorInsideMiniCart, partnershipCode: partnershipCode, partnershipWarning: partnershipWarning, shouldKeepMiniCartOpen: isKeepingMiniCartOpenAllowed && shouldKeepMiniCartOpen, shouldShowPartnershipWarning: shouldShowPartnershipWarning }, props))); }, tooltipShown: shouldKeepMiniCartOpen || undefined }, PopperProps, rest), function (_a) {
            var getTriggerProps = _a.getTriggerProps, triggerRef = _a.triggerRef;
            return (React__default.createElement(TooltipTrigger, { getTriggerProps: getTriggerProps, isMobile: isMobile, triggerComponent: triggerComponent, triggerRef: triggerRef }));
        })));
};

export { MiniCart as default };
//# sourceMappingURL=MiniCart.esm.js.map
